import { InputLabel, SxProps, Theme, Tooltip } from "@mui/material";
import React, { FunctionComponent } from "react";
import { Help } from "@mui/icons-material";
import { sxClsx } from "utils/styleClsx";

interface OwnProps {
    labelText?: string;
    className?: string;
    styles?: React.CSSProperties;
    id?: string;
    htmlFor?: string;
    shrink?: boolean;
    disabled?: boolean;
    error?: boolean;
    focused?: boolean;
    margin?: "dense";
    required?: boolean;
    variant?: "standard" | "outlined" | "filled";
    infoText?: React.ReactNode;
    showAllErrors?: boolean;
    children?: React.ReactNode;
    sx?: SxProps<Theme>;
}

type Props = OwnProps;

const AcxInputLabel: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = (props) => {
    return (
        <InputLabel
            className={props.className}
            shrink={props.shrink}
            htmlFor={props.htmlFor}
            id={props.id}
            disabled={props.disabled}
            error={props.error}
            focused={props.focused}
            margin={props.margin}
            required={props.required}
            variant={props.variant}
            sx={sxClsx(
                {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: props.showAllErrors ? "break-spaces" : "nowrap",
                    userSelect: "none",
                    fontSize: "12px",
                    lineHeight: "16px",
                    color: (theme: Theme) => theme.palette.text.secondary,
                    fontFamily: (theme: Theme) => theme.typography.fontFamily,
                    marginBottom: (theme: Theme) => theme.spacing(0.5),
                },
                props.sx && Array.isArray(props.sx)
                    ? Object.assign({}, ...props.sx)
                    : props.sx,
                props.focused && {
                    color: (theme: Theme) => theme.palette.primary.main,
                },
                props.infoText != null && {
                    display: "flex",
                    alignItems: "center",
                },
            )}
        >
            {props.children ?? props.labelText}
            {props.infoText ? (
                <Tooltip title={props.infoText} arrow placement="top-start">
                    <Help
                        color="primary"
                        sx={(theme) => ({
                            fontSize: "18px !important",
                            marginLeft: theme.spacing(1),
                            cursor: "help",
                        })}
                    />
                </Tooltip>
            ) : null}
        </InputLabel>
    );
};

export default AcxInputLabel;
